import { Logger } from '../../utils/helperMethods'
import { FileLoader, FileMap } from './FileLoader'

export class RecipeFileLoader extends FileLoader {
  /* istanbul ignore next */
  public static loadFilesWithWebpack = (): FileMap => {
    //
    const fileMap: FileMap = {}
    try {
      const requireContext = require.context('../../recipes/', false, /\.json$/)

      requireContext.keys().forEach((file) => {
        const fileWithoutExtension = file.split('/').pop().split('.').shift()
        try {
          fileMap[fileWithoutExtension] = requireContext(file)
        } catch (errorResult) {
          const message = `RecipeLoader.loadFilesWithWebpack. Error reading file ${fileWithoutExtension} with message: ${errorResult.message}`
          throw Error(message)
        }
      })
    } catch (errorRequire) {
      const message = `RecipeLoader.loadFilesWithWebpack. Load recipes from directory '../../../../recipes/' Error: ${JSON.stringify(
        errorRequire.message
      )}`
      throw Error(message)
    }

    return fileMap
  }
}

interface RecipeMap {
  [file: string]: Record<string, unknown>
}
export class LoaderRecipe {
  public readRecipeFile = (
    fileName: string,
    version: string
  ): Record<string, unknown> => {
    //
    const fileNameVersion = fileName + '_' + version
    if (fileNameVersion in this.recipeMap) {
      return this.recipeMap[fileNameVersion]
    }

    throw Error(`File [${fileNameVersion}] was not found`)
  }

  public constructor(dirName = '../../recipes/') {
    //
    try {
      this.recipeMap = this.loadRecipes(dirName)
    } catch (errorLoad) {
      Logger.strError(`On LoaderRecipe.constructor:  ${errorLoad}`)
      throw errorLoad
    }
  }

  private loadRecipes = (dirName?: string): FileMap => {
    //
    try {
      const fs = require('fs')
      if (fs) {
        return RecipeFileLoader.loadFilesWithNode(dirName)
      }
    } catch (error) {
      Logger.log(
        'Error loading fs module. Falling back to webpack. Error: ',
        error
      )

      /* istanbul ignore next */
      return RecipeFileLoader.loadFilesWithWebpack()
    }
  }

  readonly recipeMap: RecipeMap = {}
}

export default RecipeFileLoader
